export const educationOptions = [
  { label: 'Infantil', value: 'kindergarten' },
  { label: 'Fundamental', value: 'elementary' },
  { label: 'Médio', value: 'high_school' },
  { label: 'Superior', value: 'superior' },
  { label: 'Técnico', value: 'technical' },
  { label: 'Mestrado/Doutorado', value: 'masters_doctorate' },
  {
    label: 'Pós Graduação/Especialização',
    value: 'postgraduate_specialization'
  }
];

export const genderOptions = [
  { label: 'Masculino', value: 'male' },
  { label: 'Feminino', value: 'female' }
];

export const nationalityOptions = [
  { label: 'Brasileiro(a) nato(a)', value: 'brasileiro-nato' },
  { label: 'Brasileiro(a) naturalizado(a)', value: 'brasileiro-naturalizado' },
  { label: 'Estrangeiro(a)', value: 'estrangeiro' }
];
